import routes from "../routes/routes";
import { ROUTE_PERMISSIONS } from "../routes/routePermissions";

/**
 * Obtiene la ruta inicial por defecto según los permisos del usuario.
 * 1. Si es super-usuario o rol 1, accede a Home ("/").
 * 2. Si tiene permiso para Home (PATHS.INICIO), accede a Home ("/").
 * 3. Si no tiene permiso para Home, busca en orden el primer módulo privado autorizado.
 * 4. Si no tiene ningún módulo permitido, retorna routes.error ("/404").
 *
 * @param {Function} hasPermission - Función de verificación de permisos.
 * @param {Object} user - Objeto de usuario actual.
 * @param {Array} routesList - Lista opcional de rutas configuradas.
 */
export const getDefaultRouteForUser = (hasPermission, user, routesList = []) => {
  if (user?.es_supersu || String(user?.rol) === "1") {
    return routes.home;
  }

  if (typeof hasPermission !== "function") {
    return routes.home;
  }

  // 1. Si tiene acceso a Home
  if (hasPermission(ROUTE_PERMISSIONS[routes.home])) {
    return routes.home;
  }

  // 2. Si se proporciona lista de rutas con sus permisos (ej. desde routesConfig)
  if (Array.isArray(routesList) && routesList.length > 0) {
    const match = routesList.find(
      (r) => !r.public && r.path !== routes.home && r.path !== routes.error && r.permission && hasPermission(r.permission)
    );
    if (match) return match.path;
  }

  // 3. Orden canónico de evaluación para módulos privados
  const priorityRoutes = [
    routes.citologia,
    routes.planParto,
    routes.paiRegistro,
    routes.dashboard,
    routes.indicadorGubernamental,
    routes.informe,
    routes.reportesNormativos,
    routes.maestro,
    routes.carguePacientesMasivos,
    routes.logsServicios,
    routes.baseDocumental,
    routes.calculadora,
    routes.enlaces,
    routes.resultados,
    routes.soporte,
  ];

  for (const path of priorityRoutes) {
    const perm = ROUTE_PERMISSIONS[path];
    if (perm && hasPermission(perm)) {
      return path;
    }
  }

  return routes.error;
};

